import React, { useState } from 'react';
import { Button, TextArea, Form } from 'semantic-ui-react';
import { API } from "aws-amplify";

import './cmp_editor.css';

export default function CMP_EDITOR({ var_translation_id, var_translation, var_translation_lng, populate_function, 
    updateStats }) {

    //  variable declarations ------------------------------------------------------------------------------------------

    const [var_ready, set_ready] = useState(true);
    const [var_loading, set_loading] = useState(false);
    const [var_error, set_error] = useState(false);
    const [var_message, set_message] = useState(false);
    const [var_translation_value, set_translation_value] = useState(var_translation);


    //  event listeners ------------------------------------------------------------------------------------------------


    //  async functions ------------------------------------------------------------------------------------------------

    async function put_translation(translation_id, translation_value) {
        const transactionby = JSON.parse(sessionStorage.getItem('authentication')).firstname + " " + JSON.parse(sessionStorage.getItem('authentication')).lastname;
        return await API_put_translation(translation_id, var_translation_lng, translation_value, transactionby);
    }

    //  API calls ------------------------------------------------------------------------------------------------------

    function API_put_translation(translation_id, lng, translation_value, transactionby) {
        localStorage.setItem('activetime', Math.floor(Date.now() / 1000));
        return API.put('translation', '/put-translation/' + translation_id, { body: { lng, translation_value, transactionby } })
            .then((response) => {
                if (response.status === true) {
                    populate_function();
                    updateStats();
                } else {
                    set_error(true);
                    set_ready(true);
                    set_loading(false);
                    set_message(response.message.toString());
                    return response.status;
                }
            });
    }


    //  event functions ------------------------------------------------------------------------------------------------

    function onClick_hide_editor(elem) {
        elem.closest('td').classList.remove('editable_form_show');
    }


    function onChange_translation_value(translation_value) {
        set_translation_value(translation_value);
    }

    function onClick_submit_translation(translation_id, translation_value) {
        set_loading(true);
        set_ready(false);
        put_translation(translation_id, translation_value);
    }


    // RENDER APP ======================================================================================================

    return (
        <>
            <div className="editable_form">
                {var_error &&
                    <div id="loginerror" className="message warning">
                        <div className="message_icon"><img src="/icons/warning 60px (d91e18).svg" alt='warning icon' /></div>
                        <div className="message_text_wrapper">
                            <div className="message_text cause">Failed::{var_message}</div>
                        </div>
                    </div>
                }
                <Form className="editable_form_textarea">
                    <TextArea rows={2} value={var_translation_value} onChange={(e) => onChange_translation_value(e.target.value)} />
                </Form>
                <div className="editable_form_submit">
                    {!var_loading ?
                        <Button type="button" primary onClick={() => var_ready ? onClick_submit_translation(var_translation_id, var_translation_value) : false}>Save</Button>
                        :
                        <Button type="button" loading primary>Save</Button>
                    }
                    <Button type="button" className="btn_secondary" onClick={(e) => var_ready ? onClick_hide_editor(e.target) : false}>Cancel</Button>
                </div>
            </div>
        </>
    )
}
